<template>
  <div>
    <v-card elevation="6">
      <div class="pa-3">
        <div class="grid_select">
          <div class="grid_header_sell">
            <div class="mx-auto">
              <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_member" :src="img_member" />
            </div>
            <div class="pt-3 pl-2" style="font-size: 26px"><b>ยอดขายแต่ละสมาชิก</b></div>
          </div>
          <div class="ma-2">
            <v-select color="#86bc3a" @input="dump_data_select" :items="year_arr" item-text="show_year"
              item-value="year_eng" v-model="selected_year_member" prepend-inner-icon="mdi-calendar-month-outline"
              label="ปี พ.ศ." hide-details="auto" outlined></v-select>
          </div>
        </div>
      </div>
      <div class="pa-3">
        <div class="grid_member">
          <div class="mr-sm-5 pr-sm-5 mr-lg-5 pr-lg-5 mr-xl-5 pr-xl-5 border_right">
            <div class="ma-3">
              <v-btn style="width: 100%;" @click="total_sell_member(1)" class="pa-6 ma-2 grad-bg-outlined"
                :class="{ 'grad-bg-active': this.btn_active === 1 }">ลูกค้าส่ง</v-btn>
            </div>
            <div class="ma-3">
              <v-btn style="width: 100%;" @click="total_sell_member(0)" class="pa-6 ma-2 grad-bg-outlined"
                :class="{ 'grad-bg-active': this.btn_active === 0 }">ลูกค้าปลีก</v-btn>
            </div>
            <div class="ma-3">
              <v-btn style="width: 100%;" @click="total_sell_member(3)" class="pa-6 ma-2 grad-bg-outlined"
                :class="{ 'grad-bg-active': this.btn_active === 3 }">พาร์ทเนอร์</v-btn>
            </div>
            <div class="ma-3">
              <v-btn style="width: 100%;" @click="total_sell_member(2)" class="pa-6 ma-2 grad-bg-outlined"
                :class="{ 'grad-bg-active': this.btn_active === 2 }">อื่น ๆ</v-btn>
            </div>
          </div>
          <div v-if="loading_chart === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
              <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
          </div>
          <div v-else style="height: 40vh !important">
            <canvas id="myChartMember"></canvas>
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import img_member from "@/assets/pay_refund.png";
import { HTTP } from "@/axios";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Sell_total_member",
  data() {
    return {
      loading_chart: false,
      img_member: img_member,
      btn_active: 1,
      selected_year_member: null,
      year_arr: [],
      graph_list: [],
      myChartMember: null,
      year: [
        { id: 1, name: 'ปี 2565' },
        { id: 2, name: 'ปี 2564' },
        { id: 3, name: 'ปี 2563' },
        { id: 4, name: 'ปี 2562' },
        { id: 5, name: 'ปี 2561' },
      ],
    }
  },
  methods: {
    async year_function() {
      this.year_arr = []
      let arr_year = [0, 1, 2]
      let count_year = new Date()
      let full_year = count_year.getFullYear()
      for (let i = 0; i < arr_year.length; i++) {
        let count_th = ((full_year + 543) - i);
        let count_eng = ((full_year) - i);
        this.year_arr.push({
          id: i,
          year_th: count_th,
          year_eng: count_eng,
          show_year: 'ปี ' + count_th,
        })
      }
      this.selected_year_member = this.year_arr[0].year_eng
      await this.dump_data_select()
    },
    async dump_data_select() {
      this.graph_list = []
      await HTTP.post('/dashboards/salespermember', {
        year: this.selected_year_member,
        customer_type: 1,
      }).then((res) => {
        if (res.data.success === true) {
          res.data.object.forEach((data) => {
            if (this.btn_active == 0) {
              this.graph_list.push(parseFloat(data.order))
            }
            if (this.btn_active == 1) {
              this.graph_list.push(parseFloat(data.order_wholesale))
            }
            if (this.btn_active == 2) {
              this.graph_list.push(parseFloat(data.order_other))
            }
            if (this.btn_active == 3) {
              this.graph_list.push(parseFloat(data.order_partner))
            }
          })
          if (this.myChartMember !== null) {
            this.myChartMember.destroy()
          }
          this.chart_member()
        }
      })
    },
    chart_member() {
      console.log(this.graph_list);
      let data = {
        labels: this.$store.state.monthThai,
        datasets: [
          {
            label: 'ยอดเงิน',
            data: this.graph_list,
            borderColor: '#8CC63E',
            backgroundColor: '#8CC63E',
            fill: false
          },
        ]
      }
      let config = {
        type: 'bar',
        data: data,
        options: {
          responsive: true,
          maintainAspectRatio: false,
        }
      }
      const ctx = document.getElementById('myChartMember').getContext('2d');
      this.myChartMember = new Chart(ctx, config)
    },
    async total_sell_member(type) {
      this.btn_active = type
      await this.dump_data_select()
    },
  },
  mounted() {
    this.year_function()
  }
}
</script>

<style scoped>
.grid_select {
  display: grid;
  grid-template-columns: 80% 20%;
}

.grid_header_sell {
  display: grid;
  grid-template-columns: 10% 90%;
}

.grid_member {
  display: grid;
  grid-template-columns: 20% 80%;
}

.border_right {
  border-right: #9b9b9b solid 2px
}

@media only screen and (max-width: 1180px) {
  .grid_select {
    display: grid;
    grid-template-columns: 70% 30%;
  }

  .grid_header_sell {
    display: grid;
    grid-template-columns: 22% 78%;
  }

  .grid_member {
    display: grid;
    grid-template-columns: 25% 75%;
  }
}

@media only screen and (max-width: 500px) {
  .grid_select {
    display: grid;
    grid-template-columns: 100%;
  }

  .grid_header_sell {
    display: grid;
    grid-template-columns: 25% 75%;
  }

  .grid_member {
    display: grid;
    grid-template-columns: 100%;
  }

  .border_right {
    border-right: none;
    margin-left: -15px !important;
  }
}
</style>
